import { useEffect, useState } from 'react';

/** Valor com atraso: so muda depois de `ms` sem novas alteracoes (debounce da simulacao e da busca). */
export function useDebounced<T>(valor: T, ms = 400): T {
  const [atual, setAtual] = useState(valor);
  useEffect(() => {
    const id = setTimeout(() => setAtual(valor), ms);
    return () => clearTimeout(id);
  }, [valor, ms]);
  return atual;
}
